"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReturnShipmentType = exports.ReturnShipmentStatus = exports.OriginalStateTypeEnum = exports.SourceStageEnum = exports.SourceIntervalEnum = void 0;
var SourceIntervalEnum;
(function (SourceIntervalEnum) {
    SourceIntervalEnum["HALF_YEARLY"] = "HalfYearly";
    SourceIntervalEnum["YEARLY"] = "Yearly";
})(SourceIntervalEnum || (exports.SourceIntervalEnum = SourceIntervalEnum = {}));
var SourceStageEnum;
(function (SourceStageEnum) {
    SourceStageEnum["ACTIVATED"] = "Activated";
    SourceStageEnum["ACTIVATING"] = "Activating";
    SourceStageEnum["CANCELED"] = "Canceled";
    SourceStageEnum["CANCELLING"] = "Cancelling";
    SourceStageEnum["EXPIRED"] = "Expired";
    SourceStageEnum["EXPIRING"] = "Expiring";
    SourceStageEnum["NO_EXTENSION"] = "NoExtension";
    SourceStageEnum["RENEWING"] = "Renewing";
    SourceStageEnum["REQUESTED"] = "Requested";
})(SourceStageEnum || (exports.SourceStageEnum = SourceStageEnum = {}));
var OriginalStateTypeEnum;
(function (OriginalStateTypeEnum) {
    OriginalStateTypeEnum["PREPARING_RETURN_PACKET"] = "PreparingReturnPacket";
    OriginalStateTypeEnum["RETURN_BASKET"] = "ReturnBasket";
    OriginalStateTypeEnum["RETURN_IMMEDIATE"] = "ReturnImmediate";
    OriginalStateTypeEnum["RETURN_PACKET_SENT"] = "ReturnPacketSent";
    OriginalStateTypeEnum["RETURN_SCHEDULED"] = "ReturnScheduled";
    OriginalStateTypeEnum["SHRED_BASKET"] = "ShredBasket";
    OriginalStateTypeEnum["STORAGE_LONG_TERM"] = "StorageLongTerm";
    OriginalStateTypeEnum["STORAGE_SHORT_TERM"] = "StorageShortTerm";
})(OriginalStateTypeEnum || (exports.OriginalStateTypeEnum = OriginalStateTypeEnum = {}));
var ReturnShipmentStatus;
(function (ReturnShipmentStatus) {
    ReturnShipmentStatus["PACKING"] = "Packing";
    ReturnShipmentStatus["SENT"] = "Sent";
})(ReturnShipmentStatus || (exports.ReturnShipmentStatus = ReturnShipmentStatus = {}));
var ReturnShipmentType;
(function (ReturnShipmentType) {
    ReturnShipmentType["IMMEDIATE"] = "Immediate";
    ReturnShipmentType["SCHEDULED"] = "Scheduled";
})(ReturnShipmentType || (exports.ReturnShipmentType = ReturnShipmentType = {}));
//# sourceMappingURL=scan-center.js.map